<script setup lang="ts">
    import {computed} from "vue";
    import {useRoute} from "vue-router";

    import {useSongBuilderProgress} from "@songfinch/customer/composables/useSongBuilderProgress";
    import {goToReferalPage} from "@songfinch/customer/composables/useReferralPage";

    const {progressStats, sections} = useSongBuilderProgress();
    const route = useRoute();

    const currentStep = computed(() => {
        let step = 0;
        sections.some(i => {
            if (i.allIds?.includes(route.name as string) || i.id === route.name) {
                step = i.stepIndex;
                return true;
            }
        });
        return step;
    });

    const completedText = computed(() => `Step ${currentStep.value} of ${progressStats.value.total}`);
</script>

<template>
    <div v-if="!$route.meta.hideSongbuilderHeader" class="root">
        <div class="header">
            <div id="progressNav" class="header-content">
                <div v-if="!$route.meta.hideProgressNav" class="toggle">
                    <span class="toggle-label">{{completedText}}</span>
                </div>
            </div>
            <a href="#" class="dismiss" aria-label="dismiss" @click.prevent="goToReferalPage">
                <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                    <path
                        d="m17 17-5-5m0 0L7 7m5 5 5-5m-5 5-5 5"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </a>
        </div>
    </div>
</template>

<style scoped>
.root {
    --progress-nav-height: 64px;
    --box-shadow-spread: 30px;
    --sheet-radius: 16px;
}

.header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: var(--progress-nav-height);
    display: grid;
    grid-template-columns: 1fr min-content;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    padding: 1rem;

    &-content {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 2rem;
    }
}

.dismiss {
    color: var(--sfc-medium-grey);
}

.toggle {
    display: flex;
    padding: 7px 14px;
    align-items: center;
    gap: 7px;
    border-radius: 100px;
    border: 1px solid rgba(131, 129, 123, 0.4);
    transition-duration: 200ms;
    transition-property: transform, opacity, background-color, color, border-color, box-shadow;
    transition-timing-function: cubic-bezier(0.2, 0, 0, 1);
    will-change: transform, opacity, background-color, color, border-color, box-shadow;

    &-label {
        color: #262420;
        font-size: 15px;
        line-height: 1;
        font-weight: 700;
        letter-spacing: 0.5px;
        text-transform: uppercase;
    }

    &-icon {
        width: 16px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;

        & svg {
            pointer-events: none;
            user-select: none;
            height: auto;
        }
    }
}
</style>
